<div id="module-cards-list" fxLayout="row wrap" fxLayoutAlign="start">
    <span id="ruler-2" class="ruler"></span>
    <div class="w-100-p" *ngIf="dataSource">
        <mat-table #table [dataSource]="dataSource" matSort>
            <!-- Avatar Column -->
            <ng-container matColumnDef="avatar">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let moduleUser" class="avatar-cell">
                    <div #avatarCell *ngIf="moduleUser.module.image; else noModuleImage">
                        <img
                            class="avatar"
                            [class.square]="moduleUser.module.kind === ModuleKind.ProgramExecution"
                            [ngStyle]="moduleUser.module.kind === ModuleKind.ProgramExecution && { width: '72px' }"
                            [alt]="moduleUser.module.name"
                            [src]="moduleUser.module.image.thumbUrl"
                        />
                    </div>
                    <ng-template #noModuleImage>
                        <div #avatarCell>
                            <div class="avatar module-icon-container no-image">
                                <mat-icon class="bg-icon" svgIcon="bg_illustration"></mat-icon>
                            </div>
                        </div>
                    </ng-template>
                </mat-cell>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="name">
                <mat-header-cell class="px-24" *matHeaderCellDef mat-sort-header>{{ 'GENERAL.PROPERTY.NAME' | translate }}</mat-header-cell>
                <mat-cell #nameCell *matCellDef="let moduleUser" class="px-24" fxLayout="column" fxLayoutAlign="center stretch">
                    <div fxLayout="row" fxLayoutAlign="start center" class="name-with-type-icon w-100-p min-w-0">
                        <mat-icon class="icon-18 mr-8 shrink-0" [svgIcon]="moduleUser.module | getModuleIcon"></mat-icon>
                        <a
                            (click)="enableModuleRedirect ? goToModule(moduleUser.module) : null"
                            (keyup.enter)="enableModuleRedirect ? goToModule(moduleUser.module) : null"
                            tabindex="0"
                            class="text-truncate font-semibold min-w-0"
                            [ngClass]="{ pointer: enableModuleRedirect }"
                            [tooltipIfTruncated]="moduleUser.module.name"
                            >{{ moduleUser.module.name }}</a
                        >
                    </div>
                    <div fxLayoutAlign="start center" *ngIf="moduleUser.module.tags.length">
                        <mat-chip-set #chipList class="mr-8 py-8" tabIndex="-1">
                            <mat-chip
                                *ngFor="let tag of moduleUser.module.tags | filterTags: nameCell:this"
                                (click)="filterByTag(tag)"
                                class="pointer"
                                [style.background]="tag.color"
                                [disableRipple]="true"
                                tabIndex="-1"
                            >
                                {{ tag.name }}
                            </mat-chip>
                        </mat-chip-set>
                        <ng-container *ngIf="chipList._chips && chipList._chips.length < moduleUser.module.tags.length">
                            <div #more class="more-tags">...</div>
                            <app-tags-card [tags]="moduleUser.module.tags" [target]="more" (clickedTag)="filterByTag($event)"> </app-tags-card>
                        </ng-container>
                    </div>
                </mat-cell>
            </ng-container>

            <!-- Start Date Column -->
            <ng-container matColumnDef="startDate">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-sm>{{ 'GENERAL.PROPERTY.START_DATE' | translate }}</mat-header-cell>
                <mat-cell
                    *matCellDef="let moduleUser"
                    fxHide
                    fxShow.gt-sm
                    tabindex="0"
                    attr.aria-label="{{ 'GENERAL.PROPERTY.START_DATE' | translate }} {{ moduleUser.module.startDate | date: 'shortDate' }}"
                >
                    <p class="text-truncate">
                        {{ moduleUser.module.startDate | date: 'shortDate' }}
                    </p>
                </mat-cell>
            </ng-container>

            <!-- End Date Column -->
            <ng-container matColumnDef="endDate">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-sm>{{ 'GENERAL.PROPERTY.END_DATE' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let moduleUser" fxHide fxShow.gt-sm>
                    <p class="text-truncate" tabindex="0" attr.aria-label="{{ 'GENERAL.PROPERTY.END_DATE' | translate }} {{ moduleUser.module.endDate | date: 'shortDate' }}">
                        {{ moduleUser.module.endDate | date: 'shortDate' }}
                    </p>
                </mat-cell>
            </ng-container>

            <!-- Status column -->
            <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef tabindex="0" class="status">{{ 'GENERAL.PROPERTY.STATUS' | translate }}</mat-header-cell>
                <mat-cell
                    *matCellDef="let moduleUser"
                    class="status"
                    tabindex="0"
                    attr.aria-label="{{ 'GENERAL.PROPERTY.STATUS' | translate }} {{ moduleUser.module.status | getStatus: moduleStatuses:'translationLabel' | translate }}"
                >
                    <p class="text-truncate">
                        {{ moduleUser.module.status | getStatus: moduleStatuses:'translationLabel' | translate }}
                    </p>
                </mat-cell>
            </ng-container>

            <!-- Section Progress -->
            <ng-container matColumnDef="progress">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-sm>{{ 'GENERAL.LABEL.PROGRESS' | translate }} </mat-header-cell>
                <mat-cell *matCellDef="let moduleUser" fxHide fxShow.gt-sm>
                    <div class="sections-completed-progress-container" fxLayout="row" fxLayoutAlign="space-between center" *ngIf="moduleUser.moduleUserProgress">
                        <div
                            fxLayout="row"
                            fxLayoutAlign="space-between center"
                            tabindex="0"
                            attr.aria-label="{{ 'GENERAL.LABEL.PROGRESS_BAR' | translate }}"
                            *ngIf="moduleUser.module.kind === ModuleKind.ProgramExecution; else sectionsCompletedProgress"
                        >
                            <mat-progress-bar mode="determinate" [value]="moduleUser.moduleUserProgress?.programProgress"> </mat-progress-bar>
                            <span tabindex="0"> {{ moduleUser.moduleUserProgress?.coursesCompleted }}/{{ moduleUser.moduleUserProgress?.coursesBooked }} </span> &nbsp;
                            <span tabindex="0"> {{ 'PAGE.USER_FORM.TAB.CERTIFICATES.CONTENT_PROGRESS.LABELS.COURSES' | translate }} </span>
                        </div>
                        <ng-template #sectionsCompletedProgress>
                            <div
                                fxLayout="row"
                                fxLayoutAlign="space-between center"
                                tabindex="0"
                                attr.aria-label="{{ 'GENERAL.LABEL.PROGRESS_BAR' | translate }}"
                                *ngIf="moduleUser.module.hasTrackProgress"
                            >
                                <mat-progress-bar mode="determinate" [value]="(moduleUser.moduleUserProgress?.completedSectionsCount * 100) / moduleUser.module.sectionCount">
                                </mat-progress-bar>
                                <span tabindex="0"> {{ moduleUser.moduleUserProgress?.completedSectionsCount || 0 }}/{{ moduleUser.module.sectionCount }} </span> &nbsp;
                                <span tabindex="0"> {{ 'PAGE.USER_FORM.TAB.CERTIFICATES.CONTENT_PROGRESS.LABELS.SECTIONS' | translate }} </span>
                            </div>
                        </ng-template>
                    </div>
                </mat-cell>
            </ng-container>

            <!-- Final Grade -->
            <ng-container matColumnDef="finalGrade">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-sm>{{ 'FINAL_GRADE.LABEL.GRADE' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let moduleUser" fxHide fxShow.gt-sm>
                    <p class="text-truncate" attr.aria-label="{{ 'FINAL_GRADE.LABEL.GRADE' | translate }} {{ moduleUser.userFinalGrade?.grade?.displayValue }}">
                        {{ moduleUser.userFinalGrade?.grade?.displayValue }}
                    </p>
                </mat-cell>
            </ng-container>

            <!-- Certificate -->
            <ng-container matColumnDef="certificate">
                <mat-header-cell *matHeaderCellDef tabindex="0" fxHide fxShow.gt-sm class="pr-24">{{ 'CERTIFICATE.SINGULAR' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let moduleUser" fxHide fxShow.gt-sm class="pr-24">
                    <div fxLayout="column" fxLayoutAlign="start start">
                        <div *ngIf="moduleUser.userFinalGrade?.certificate" [class.mb-8]="moduleUser.certificates">
                            <app-certificate
                                class="max-w-full"
                                [class.mb-0]="isLast"
                                [label]="moduleUser.userFinalGrade.certificate.name"
                                [isDownloadIconVisible]="canDownloadCertificates"
                                (onClick)="canDownloadCertificates ? downloadCertificate(moduleUser.userFinalGrade.certificate) : null"
                            ></app-certificate>
                        </div>

                        <div *ngIf="moduleUser.certificates">
                            <div fxLayout="row" fxLayoutAlign="start center" *ngFor="let certificate of moduleUser.certificates; last as isLast" class="mb-4" [class.mb-0]="isLast">
                                <app-certificate
                                    class="max-w-full"
                                    [class.mb-0]="isLast"
                                    [label]="certificate.name"
                                    [isDownloadIconVisible]="canDownloadCertificates && !!certificate.filename"
                                    (onClick)="canDownloadCertificates ? downloadCertificate(certificate) : null"
                                ></app-certificate>
                            </div>
                        </div>
                    </div>
                </mat-cell>
            </ng-container>

            <!--Attendance column-->
            <ng-container matColumnDef="attendance">
                <mat-header-cell *matHeaderCellDef tabindex="0" class="attendance" fxHide fxShow.gt-sm>{{ 'PAGE.MANAGE_MODULES.MY_ATTENDANCE' | translate }} </mat-header-cell>
                <mat-cell *matCellDef="let module" class="attendance" fxHide fxShow.gt-sm>
                    <div *ngIf="module.attendance" tabindex="0" attr.aria-label="{{ 'PAGE.MANAGE_MODULES.MY_ATTENDANCE' | translate }} {{ module.attendance.percentage }}%">
                        <span> {{ module.attendance.percentage }}% </span>
                    </div>
                </mat-cell>
            </ng-container>

            <!-- Buttons Column -->
            <ng-container matColumnDef="buttons">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let moduleUser">
                    <div fxFlex="row" fxLayoutAlign="end center">
                        <button mat-icon-button [matMenuTriggerFor]="moreMenu" aria-label="More" (click)="$event.stopPropagation()">
                            <mat-icon class="mat-icon-more-vert">more_vert</mat-icon>
                        </button>

                        <mat-menu #moreMenu="matMenu" xPosition="before">
                            <button mat-menu-item aria-label="view" (click)="goToModule(moduleUser.module)" *ngIf="enableModuleRedirect">
                                <span>{{ 'LIST.USER_MODULES.BUTTON.VIEW' | translate }}</span>
                            </button>

                            <button mat-menu-item aria-label="add" (click)="addAsParticipant(moduleUser)" *ngIf="!moduleUser.isParticipant && hasTenantAdminOrUsersViewPermission">
                                <span>{{ 'FORM.ASSIGN_TO_MODULES.FIELD.ADD_AS_PARTICIPANT' | translate }}</span>
                            </button>

                            <button
                                mat-menu-item
                                aria-label="remove"
                                (click)="removeAsParticipant(moduleUser)"
                                *ngIf="moduleUser.isParticipant && moduleUser.canRemoveAsParticipant && hasTenantAdminOrUsersViewPermission"
                            >
                                <span>{{ 'FORM.ASSIGN_TO_MODULES.FIELD.REMOVE_AS_PARTICIPANT' | translate }}</span>
                            </button>

                            <button mat-menu-item aria-label="add" (click)="addAsManager(moduleUser)" *ngIf="!moduleUser.isManager && hasTenantAdminOrUsersViewPermission">
                                <span>{{ 'FORM.ASSIGN_TO_MODULES.FIELD.ADD_AS_MANAGER' | translate }}</span>
                            </button>

                            <button mat-menu-item aria-label="remove" (click)="removeAsManager(moduleUser)" *ngIf="moduleUser.isManager && hasTenantAdminOrUsersViewPermission">
                                <span>{{ 'FORM.ASSIGN_TO_MODULES.FIELD.REMOVE_AS_MANAGER' | translate }}</span>
                            </button>

                            <button mat-menu-item aria-label="set" (click)="setAsResponsible(moduleUser)" *ngIf="moduleUser.isManager && hasTenantAdminOrUsersViewPermission">
                                <span>{{
                                    (moduleUser.isResponsible ? 'FORM.ASSIGN_TO_MODULES.FIELD.UPDATE_RESPONSIBLE_ROLE' : 'FORM.ASSIGN_TO_MODULES.FIELD.ADD_AS_RESPONSIBLE')
                                        | translate
                                }}</span>
                            </button>

                            <button
                                mat-menu-item
                                aria-label="remove"
                                (click)="removeAsResponsible(moduleUser)"
                                *ngIf="moduleUser.isResponsible && hasTenantAdminOrUsersViewPermission"
                            >
                                <span>{{ 'FORM.ASSIGN_TO_MODULES.FIELD.REMOVE_AS_RESPONSIBLE' | translate }}</span>
                            </button>
                        </mat-menu>
                    </div>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let audienceUser; columns: displayedColumns" class="user" matRipple> </mat-row>
        </mat-table>
    </div>
</div>
